<template>
  <div class="main_div">
    <div style="height: auto" :key="componentKey">
      <n-space>
        <NCard
          style="
            margin-top: 20px;
            margin-left: 80px;
            border: 0px;
            min-width: 800px;
          "
        >
          <n-space item-style="display: flex;" align="center">
            <div style="font-size: 20px; width: 200px; font-weight: bold">
              기관용 상품 관리
            </div>
          </n-space>
          <div class="content_delimiter_line"></div>
          <Loading v-show="loading" />
          <div>
            <button @click="goToRegisterOrganization" class="action-button">
              신규 상품 등록
            </button>
            <div v-if="listLoading" class="loading-indicator">
              상품 목록을 불러오는 중...
            </div>
            <!-- <div v-if="error" class="error-message">{{ error }}</div> -->
            <div v-if="!listLoading && !error">
              <div class="table-container">
                <n-data-table
                  v-if="products.length > 0"
                  :columns="columns"
                  :data="products"
                  :pagination="false"
                  :bordered="true"
                />
                <p v-else>등록된 상품이 없습니다.</p>
              </div>
              <div
                v-if="products.length > 0"
                class="pagination-controls"
                style="margin-top: 15px; text-align: center"
              >
                <n-button
                  @click="wrappedGoToPreviousPage"
                  :disabled="currentPage === 1"
                  style="margin-right: 8px"
                >
                  이전 페이지
                </n-button>
                <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage">
                  다음 페이지
                </n-button>
              </div>
            </div>
          </div>
        </NCard>

        <n-modal
          v-model:show="showDetailsModal"
          preset="card"
          style="width: 600px"
          title="진단 상품 상세 정보"
          @after-leave="onDetailsModalClose"
        >
          <div v-if="selectedProduct" class="organization-details-content">
            <n-descriptions
              label-placement="left"
              bordered
              :column="1"
              size="small"
            >
              <n-descriptions-item label="ID">
                {{ selectedProduct.SK }}
              </n-descriptions-item>
              <n-descriptions-item label="상품명">
                {{ selectedProduct.name }}
              </n-descriptions-item>
              <n-descriptions-item label="가격">
                {{ common.formatNumberWithCommas(selectedProduct.price) }}
              </n-descriptions-item>
              <n-descriptions-item label="타입">
                {{ selectedProduct.type }}
              </n-descriptions-item>
              <n-descriptions-item label="설명">
                {{ selectedProduct.description || "N/A" }}
              </n-descriptions-item>
              <n-descriptions-item label="기관용 템플릿 폼 ID">
                {{ selectedProduct.template_form_id || "N/A" }}
              </n-descriptions-item>
              <n-descriptions-item label="개인용 템플릿 폼 ID">
                {{ selectedProduct.personal_template_form_id || "N/A" }}
              </n-descriptions-item>
              <n-descriptions-item label="상태">
                {{ selectedProduct.status ? selectedProduct.status : "판매중" }}
              </n-descriptions-item>
            </n-descriptions>
            <div style="text-align: right; margin-top: 20px">
              <n-button @click="closeDetailsModal" type="primary"
                >닫기</n-button
              >
            </div>
          </div>
        </n-modal>

        <!-- 신규 기관 등록 폼/모달을 위한 플레이스홀더 -->
        <n-modal
          v-model:show="showRegistrationForm"
          preset="card"
          style="width: 600px"
          title="신규 상품 등록"
          @after-leave="onRegistrationModalClose"
        >
          <n-form
            ref="registrationFormRef"
            :model="registrationModel"
            :rules="registrationRules"
            label-placement="left"
            label-width="auto"
            require-mark-placement="right-hanging"
          >
            <n-form-item label="상품명" path="name">
              <n-input
                v-model:value="registrationModel.name"
                placeholder="상품명"
              />
            </n-form-item>
            <n-form-item label="가격" path="price">
              <n-input-number
                v-model:value="registrationModel.price"
                placeholder="가격"
                style="width: 100%"
                :min="0"
              />
            </n-form-item>
            <n-form-item label="타입" path="type">
              <n-input
                v-model:value="registrationModel.type"
                placeholder="타입 (예: putt_e)"
              />
            </n-form-item>
            <n-form-item label="기관용 템플릿 폼 ID" path="template_form_id">
              <n-input
                v-model:value="registrationModel.template_form_id"
                placeholder="기관용 템플릿 폼 ID"
              />
            </n-form-item>
            <n-form-item
              label="개인용 템플릿 폼 ID"
              path="personal_template_form_id"
            >
              <n-input
                v-model:value="registrationModel.personal_template_form_id"
                placeholder="개인용 템플릿 폼 ID"
              />
            </n-form-item>
            <n-form-item label="설명" path="description">
              <n-input
                v-model:value="registrationModel.description"
                type="textarea"
                placeholder="진단에 대한 간략한 설명"
              />
            </n-form-item>
          </n-form>
          <div class="registration-form-content">
            <div style="text-align: right; margin-top: 20px">
              <n-button
                @click="showRegistrationForm = false"
                type="tertiary"
                style="margin-right: 10px"
                >취소</n-button
              >
              <n-button
                type="primary"
                @click="handleRegistrationSubmit"
                :loading="isRegistering"
                >등록</n-button
              >
              <!-- 실제 등록 로직 연결 필요 -->
            </div>
          </div>
        </n-modal>
        <!-- Edit Product Modal -->
        <n-modal
          v-model:show="showEditModal"
          preset="card"
          style="width: 600px"
          title="상품 정보 수정"
          @after-leave="onEditModalClose"
        >
          <n-form
            ref="editFormRef"
            :model="editModel"
            :rules="editRules"
            label-placement="left"
            label-width="auto"
            require-mark-placement="right-hanging"
          >
            <n-form-item label="상품 ID" path="prod_id">
              <n-input v-model:value="editModel.SK" disabled />
            </n-form-item>
            <n-form-item label="상품명" path="name">
              <n-input v-model:value="editModel.name" placeholder="진단 이름" />
            </n-form-item>
            <n-form-item label="가격" path="price">
              <n-input-number
                v-model:value="editModel.price"
                placeholder="가격"
                style="width: 100%"
                :min="0"
              />
            </n-form-item>
            <n-form-item label="타입" path="type">
              <n-input
                v-model:value="editModel.type"
                placeholder="타입 (예: putt_e)"
              />
            </n-form-item>
            <n-form-item label="기관용 템플릿 폼 ID" path="template_form_id">
              <n-input
                v-model:value="editModel.template_form_id"
                placeholder="기관용 템플릿 폼 ID"
              />
            </n-form-item>
            <n-form-item
              label="개인용 템플릿 폼 ID"
              path="personal_template_form_id"
            >
              <n-input
                v-model:value="editModel.personal_template_form_id"
                placeholder="개인용 템플릿 폼 ID"
              />
            </n-form-item>
            <n-form-item label="설명" path="description">
              <n-input
                v-model:value="editModel.description"
                type="textarea"
                placeholder="진단에 대한 간략한 설명"
              />
            </n-form-item>
          </n-form>
          <div style="text-align: right; margin-top: 20px">
            <n-button
              @click="closeEditModal"
              type="tertiary"
              style="margin-right: 10px"
              >취소</n-button
            >
            <n-button
              type="primary"
              @click="handleUpdateSubmit"
              :loading="isUpdating"
              >확인</n-button
            >
          </div>
        </n-modal>
      </n-space>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, nextTick } from "vue";
import { getCallable } from "@/config/env";
import {
  NSpace,
  NCard,
  NDataTable,
  NButton,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NForm,
  NFormItem,
  NInput,
  NInputNumber,
  NInputGroup,
  FormInst,
  FormRules,
  NIcon,
  NSpin,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { usePagination } from "@/composables/usePagination";
const { loading } = useAuth(); // 전역 로딩 상태
import { Product } from "@/model/product";

const componentKey = ref(0); // To force re-render if needed
const getProductsCallable = getCallable("getProducts");
const updateProductCallable = getCallable("updateProduct");
const addProductCallable = getCallable("addProduct");

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();

// usePagination 적용
const {
  paginatedItems: products, // 데이터 명칭 변경
  listLoading, // usePagination의 listLoading 사용
  error, // usePagination의 error 사용
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshProducts,
} = usePagination<Product>(
  async (params) => getProductsCallable(params), // API 호출 함수 전달
  10 // 페이지 크기 (예시로 10개 설정)
);

// 전역 로딩 상태를 포함하는 래퍼 함수들
async function wrappedRefreshProducts() {
  loading.value = true;
  await composableRefreshProducts();
  loading.value = false;
}

const selectedProduct = ref<Product | null>(null);
const showRegistrationForm = ref<boolean>(false);
const showDetailsModal = ref<boolean>(false);

const registrationFormRef = ref<FormInst | null>(null);
const registrationModel = ref<Partial<Product>>({
  name: "",
  price: 0,
  type: "",
  description: "",
  template_form_id: "",
  personal_template_form_id: "",
});
const showEditModal = ref<boolean>(false);
const isRegistering = ref<boolean>(false);
const editFormRef = ref<FormInst | null>(null);
const editModel = ref<Partial<Product>>({
  SK: "",
  name: "",
  price: 0,
  type: "",
  grades: "",
  description: "",
  status: "",
  template_form_id: "",
  personal_template_form_id: "",
});
const isUpdating = ref<boolean>(false);

const registrationRules: FormRules = {
  name: [
    {
      required: true,
      message: "상품명 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  price: [
    { required: true, message: "가격을 입력해주세요." },
    {
      type: "number",
      message: "가격은 숫자여야 합니다.",
      trigger: ["input", "blur"],
    },
  ],
  type: [
    {
      required: true,
      message: "진단 타입(ex> putt_e)을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
};

const columns = [
  {
    title: "종류",
    key: "SK",
    resizable: true,
    render(row: Product) {
      if (row.SK.startsWith("personal")) {
        return "진단 검사";
      } else if (row.SK.startsWith("org")) {
        return "집단 분석";
      } else if (row.SK.startsWith("offline")) {
        return "상담코칭";
      } else if (row.SK.startsWith("activity")) {
        return "Activity";
      } else if (row.SK.startsWith("expert")) {
        return "전문가교육";
      } else {
        return "기타";
      }
    },
  },
  {
    title: "상품명",
    key: "name",
    resizable: true,
  },
  {
    title: "가격",
    key: "price",
    resizable: true,
    render(row: Product) {
      return common.formatNumberWithCommas(row.price);
    },
  },
  {
    title: "타입",
    key: "type",
    resizable: true,
  },
  {
    title: "상태",
    key: "status",
    resizable: true,
    render(row: Product) {
      if (!row.status) {
        return "판매중";
      } else {
        // TODO : 아직은 상태 값이 정해지지 않았음.
        return row.status;
      }
    },
  },
  {
    title: "상세보기",
    key: "actions",
    render(row: Product) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => displayProductDetails(row, false),
        },
        { default: () => "상세" }
      );
    },
  },
  {
    title: "정보 수정",
    key: "actions",
    render(row: Product) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => displayProductDetails(row, true),
        },
        { default: () => "수정" }
      );
    },
  },
];

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  await composableGoToNextPage();
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  await composableGoToPreviousPage();
}

function goToRegisterOrganization() {
  showRegistrationForm.value = true;
  // 필요하다면 여기서 registrationModel 초기화 또는 사전 설정
}

function displayProductDetails(product: Product, isUpdate = false) {
  showRegistrationForm.value = false;
  loading.value = true;
  error.value = null;
  selectedProduct.value = product; // Type assertion
  if (isUpdate) openEditModal(product);
  else showDetailsModal.value = true;
  loading.value = false;
}

function openEditModal(product: Product) {
  // Product 객체의 복사본을 editModel에 할당하여 원본 데이터 변경 방지
  editModel.value = { ...product };
  showEditModal.value = true;
  nextTick(() => {
    editFormRef.value?.restoreValidation();
  });
}

function closeDetailsModal() {
  showDetailsModal.value = false;
}

function onDetailsModalClose() {}

function closeEditModal() {
  showEditModal.value = false;
}

function onEditModalClose() {
  editModel.value = {
    // 폼 모델 초기화
    SK: "",
    name: "",
    price: 0,
    type: "",
    grades: "",
    description: "",
    status: "",
    template_form_id: "",
    personal_template_form_id: "",
  };
  isUpdating.value = false;
}

function onRegistrationModalClose() {
  registrationModel.value = {
    name: "",
    price: 0,
    type: "",
    description: "",
    template_form_id: "",
    personal_template_form_id: "",
  };
  isRegistering.value = false;
  registrationFormRef.value?.restoreValidation();
}

async function handleUpdateSubmit() {
  try {
    await editFormRef.value?.validate();
  } catch (errors) {
    message.error("입력 내용을 확인해주세요.");
    return;
  }

  if (!editModel.value.SK) {
    message.error("수정할 상품 정보가 올바르지 않습니다.");
    return;
  }
  isUpdating.value = true;
  try {
    const payload = { ...editModel.value };
    const result = await updateProductCallable(payload);

    if (common.evalFunctionResult(result)) {
      message.success("상품 정보가 성공적으로 수정되었습니다.");
      closeEditModal();
      await wrappedRefreshProducts(); // 목록 새로고침
    } else {
      notification.error({
        title: "수정 실패",
        description: `상품 정보 수정 중 오류 발생: ${
          common.getResultError(result) || "알 수 없는 오류"
        }`,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("상품 수정 API 호출 실패:", err);
    notification.error({
      title: "수정 실패",
      description: `상품 정보 수정 중 심각한 오류 발생: ${
        err.message || "서버 통신 오류"
      }`,
      duration: 3000,
    });
  } finally {
    isUpdating.value = false;
  }
}

async function handleRegistrationSubmit() {
  try {
    await registrationFormRef.value?.validate();
  } catch (errors) {
    message.error("입력 내용을 확인해주세요.");
    return;
  }

  isRegistering.value = true;
  try {
    const payload: Partial<Product> = {
      ...registrationModel.value,
      price: Number(registrationModel.value.price), // 확실히 숫자로 전달
    };
    const result = await addProductCallable(payload);

    if (common.evalFunctionResult(result)) {
      message.success("상품이 성공적으로 등록되었습니다.");
      showRegistrationForm.value = false; // 모달 닫기
      await wrappedRefreshProducts(); // 목록 새로고침
    } else {
      notification.error({
        title: "등록 실패",
        content: `상품 등록 중 오류 발생: ${
          common.getResultError(result) || "알 수 없는 오류"
        }`,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("상품 등록 API 호출 실패:", err);
    notification.error({
      title: "등록 실패",
      content: `상품 등록 중 심각한 오류 발생: ${
        err.message || "서버 통신 오류"
      }`,
      duration: 3000,
    });
  } finally {
    isRegistering.value = false;
  }
}

onMounted(async () => {
  wrappedRefreshProducts();
});
</script>

<style scope></style>
